<template>
  <div class="pages">
    <!-- loading -->
    <transition name="loading">
      <Loading v-if="loading" />
    </transition>

    <!-- 视频组件 -->
    <transition name="opacityEnLe">
      <videoCom v-show="videoCom" />
    </transition>

    <!-- 罗盘 + 视频 -->
    <transition name="opacityEnLe">
      <ResVideo v-if="resVideo" />
    </transition>

    <!-- 最终海报页面 -->

    <div v-if="lastShow">
      <transition name="opacityEnLe">
        <Last v-show="lastCom" />
      </transition>
    </div>

    <!-- audio -->
    <audio
      ref="audio"
      preload="auto"
      loop="loop"
      src="https://n.v.netease.com/2019/0304/4fd23458c5d7629f6ff18bcf92925fb6.mp3"
    ></audio>
    <Share />
  </div>
</template>

<script>
import Loading from "./loading";
import videoCom from "./videoCom";
import ResVideo from "./resVideo";
import Share from "./share";
import Last from "./last";
import { mapActions } from "vuex";
import { isWeiXin } from "@/tools";
export default {
  name: "Pages",
  components: {
    Loading,
    videoCom,
    ResVideo,
    Last,
    Share
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    videoCom() {
      return this.$store.state.videoCom;
    },
    resVideo() {
      return this.$store.state.resVideo;
    },
    lastCom() {
      return this.$store.state.lastCom;
    },
    lastShow() {
      return this.$store.state.lastShow;
    }
  },
  mounted() {
    this.useAudio();

    this.handleIsWX(); // 是不是微信浏览器
  },
  methods: {
    ...mapActions(["audioObjFn", "isWeiXinFn"]),
    useAudio() {
      this.audioObjFn(this.$refs.audio);
    },
    handleIsWX() {
      if (isWeiXin()) {
        // 是微信浏览器
        this.isWeiXinFn(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";

.opacityEnLe-enter-active,
.opacityEnLe-leave-active,
.loading-leave-active {
  transition: all 1s ease;
}

.opacityEnLe-enter,
.opacityEnLe-leave-to,
.loading-leave-to {
  opacity: 0;
}

.loading-leave,
.opacityEnLe-leave,
.opacityEnLe-enter-to {
  opacity: 1;
}

.pages {
  @include wh(100%, 100%);
}
</style>


